<template>
    <v-card  flat class="my-6 rounded-xl pa-6 justify-center d-flex text-center">
        <div>
            <v-icon size="100">mdi-bell-off</v-icon>

            <h2>Nothing to see here, yet</h2>
            <p class="my-3"> Notifications will display once you start <br /> making transactions</p>
        </div>

    </v-card>
</template>